"use strict";
module.exports = {
    entityModel: 'brand',
    events: {
        BRAND_UPDATED: 'BRAND_UPDATED',
        BRAND_CREATED: 'BRAND_CREATED',
        BRAND_ACTIVATED: 'BRAND_ACTIVATED',
        BRAND_DEACTIVATED: 'BRAND_DEACTIVATED',
    },
    actions: {
        get: 'v1.brand.get',
        list: 'v1.brand.list',
        writeBrand: 'v1.brand.writeBrand',
        activate: 'v1.brand.activate',
        deactivate: 'v1.brand.deactivate',
        upsert: 'v1.brand.upsert',
        upsertWhenEmpty: 'v1.brand.upsertWhenEmpty',
        updateWhenEmpty: 'v1.brand.updateWhenEmpty',
        update: 'v1.brand.update',
    },
};
